module.exports = __webpack_public_path__ + "img/mxr-noise-clamp.65a20f50.jpg";